<template>
    <div class="b1">
        <div class="bg"></div>
        <div class="popup1" v-if="flag">
            <div class="p_bg" @click.stop="flag = false"></div>
        </div>
        <div class="body">
            <div class="center">
                <div class="c_left">
                    <div>体验课堂</div>
                    <div>总数：{{ list.length || 0 }}</div>
                </div>
                <div class="c_right" @click="centerDialogVisible = true">新建体验课堂</div>
            </div>
            <div class="bottom">
                <div class="b_top">
                    <div>课题</div>
                    <div>学科</div>
                    <div>状态</div>
                    <div>分析状态</div>
                    <div>二维码</div>
                    <!-- <div></div> -->
                    <div>创建时间</div>
                    <div>操作</div>
                </div>
                <div class="b_bottom" :infinite-scroll-distance="50" :infinite-scroll-immediate="false"
                    v-infinite-scroll="load">
                    <div class="bb_item" v-for="(item, index) in list" :key="index">
                        <div class="bb_1">{{ item.courseName }}</div>
                        <div class="bb_2">{{ item.subjectName }}</div>
                        <div class="bb_3">
                            <div>{{ item.status == 0 ? '上课中' : item.status == 1 ? '结课' : '未上课' }}</div>
                        </div>
                        <div class="bb_4">
                            <!-- 评价状态 0-未评价 1-评价中 2-评价成功 3-评价失败 -->
                            <div>{{ item.evaluateStatus == 0 ? '未评价' : item.evaluateStatus == 1 ? '评价中' :
                                item.evaluateStatus
                                    == 2 ? '评价成功' : '评价失败' }}</div>
                        </div>
                        <div class="bb_5">
                            <el-image class="b5img" :src="webImg + item.qrCode"
                                :preview-src-list="[webImg + item.qrCode]"></el-image>
                        </div>
                        <!-- <div class="bb_6">
                            <div class="bb6 line2_" :title="item.evaluate">
                                {{ item.evaluate }}
                            </div>
                        </div> -->
                        <div class="bb_7">{{ item.createTime }}</div>
                        <div class="bb_8">
                            <div class="bb8_btn1"
                                @click="$router.push({ path: '/classroomInfo', query: { id: item.id } })">课堂管理</div>
                            <!-- btn_edit(item, index) -->
                            <!-- <div class="bb8_btn1" @click="btn_edit(item, index)">修改</div> -->
                            <template>
                                <el-popconfirm title="是否确定删除该课堂？" @confirm="btn_del(item.id)">
                                    <el-button type="text" class="bb8_btn2" slot="reference">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </div>
                    </div>
                    <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
                </div>
            </div>
        </div>
        <el-dialog :modal-append-to-body="false" title="新建体验课堂" :visible.sync="centerDialogVisible" width="30%" center>
            <span style="color: red;font-weight: bold;font-size: 14px;">*体验课堂只能同时存在一个，新建后将会覆盖之前的课堂</span>
            <div style="height: 10px;"></div>
            <el-select :popper-append-to-body="false" v-model="selectId" placeholder="请选择课堂模板">
                <el-option v-for="item in selectList" :key="item.id" :label="item.courseName" :value="item.id">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="btn_add">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    classInfo,
    checkPermi,
    classStudentList,
    experienceClassroomList,
    courseAdd,
    techHelperOption,
    courseDetail,
    courseEdit,
    courseRemove,
    experienceClassroomTemplateList,
    experienceClassroomAdd
} from '@/apis/index'
// import { get } from 'lodash';
export default {
    data() {
        return {
            centerDialogVisible: false,
            flag: false,
            classId: this.$route.query.id,
            info: {},
            bzrFlag: '',
            stuNum: 0,
            teacherNum: 0,
            techSectionId: '',
            courseNum: 0,
            courseName: '',
            subjectName: '',
            list: [],
            ktId: '',
            pageNum: 1,
            courseType: 1,
            isPersonal: 0,
            type: 1,
            isTeacher: this.$route.query.isTeacher,
            selectList: [],
            selectId: ''
        }
    },
    mounted() {
        if (this.$route.query.flag) {
            this.flag = true
            const query = { ...this.$route.query }; // 复制当前查询参数
            delete query.flag; // 删除 id 参数

            this.$router.push({
                path: this.$route.path,
                query
            });
        }
        this.getTemplateList()
        this.getExperienceClassroomList()
    },
    methods: {
        btn_add(){
            let loading = this.$loading({
                lock: true,
                text: '正在创建中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            experienceClassroomAdd({
                techCourseId: this.selectId,
            }).then(res => {
                this.centerDialogVisible = false
                this.pageNum = 1
                this.getExperienceClassroomList()
            }).finally(()=>{
                loading.close()
            })
        },
        getTemplateList() {
            experienceClassroomTemplateList().then(res => {
                console.log(res)
                this.selectList = res.data
            })
        },
        createClassRoom() {
            // this.flag = true
            this.$router.push({ path: '/classroomIntelligentBodyCreate', query: { id: this.ktId, techClassId: this.classId, courseType: this.courseType } })
            // this.ktId = ''
            // this.type = 1
            // this.availableItems = []
            // this.selectedItems = []
            // this.selectedSelected = []
            // this.selectedAvailable = []
            // this.getTechHelperOption()
        },
        load() {
            this.throttle(() => {
                if (this.courseNum > this.list.length) {
                    this.pageNum++
                    this.getExperienceClassroomList()
                }
            })
        },
        btn_del(ktId) {
            this.throttle(() => {
                courseRemove(ktId).then(res => {
                    console.log(res)
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getExperienceClassroomList()
                })
            })
        },
        btn_edit(item, index) {
            // this.ktId = item.id
            // this.subjectName = item.subjectName
            // this.courseName = item.courseName
            // this.availableItems = []
            // this.selectedItems = []
            // this.selectedSelected = []
            // this.selectedAvailable = []
            // this.getTechHelperOption()
            // this.flag = true

            this.$router.push({ path: '/classroomIntelligentBodyCreate', query: { id: item.id, techClassId: this.classId, courseType: this.courseType, courseName: item.courseName, subjectName: item.subjectName } })
        },
        submit() {
            this.throttle(() => {
                let loading = this.$loading({
                    lock: true,
                    text: "正在保存中，请稍候...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                if (this.courseName == '') {
                    this.$message({
                        message: '请输入课题名称',
                        type: 'warning'
                    });
                    return
                }
                if (this.subjectName == '') {
                    this.$message({
                        message: '请输入学科名称',
                        type: 'warning'
                    });
                    return
                }
                if (this.selectedItems.length == 0) {
                    this.$message({
                        message: '请选择智能体',
                        type: 'warning'
                    });
                    return
                }
                this.selectedItems.forEach(e => { e.ifChoose = true })
                if (this.ktId) {
                    courseEdit({
                        techClassHelperList: this.selectedItems,
                        courseName: this.courseName,
                        subjectName: this.subjectName,
                        techClassId: this.classId,
                        id: this.ktId,
                        courseType: this.courseType
                    }).then(res => {
                        console.log(res, 'res');
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.flag = false
                        this.$router.push({ path: '/classroomInfo', query: { id: this.ktId } })
                        this.ktId = ''
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    courseAdd({
                        techClassHelperList: this.selectedItems,
                        courseName: this.courseName,
                        subjectName: this.subjectName,
                        techClassId: this.classId,
                        courseType: this.courseType
                    }).then(res => {
                        console.log(res, 'res');
                        this.flag = false
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        // this.$router.push({ path: '/classroomIntelligentBodyCreate', query: { id: res.data } })
                        // this.$router.push({ path: '/classroomInfo', query: { id: res.data } })
                    }).finally(() => {
                        loading.close();
                    })
                }
            })
        },
        getExperienceClassroomList() {
            experienceClassroomList(this.pageNum, this.courseType, this.isTeacher).then(res => {
                console.log(res, 'experienceClassroomList');
                if (this.pageNum == 1) {
                    this.list = []
                }
                this.list = [...this.list, ...res.data]
                this.courseNum = res.total
            });
        },
        getCheckPermi() {
            checkPermi(this.classId).then((res) => {
                console.log(res, 'checkPermi');
                this.bzrFlag = res.data;
            });
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep{
    .el-select{
        width: 100% !important;
    }
    // .el-select-dropdown .el-scrollbar .el-scrollbar__wrap {
    //     overflow: scroll !important;
    // }
}
    .line1_ {
        word-break: break-all;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .line2_ {
        word-break: break-all;
        display: -webkit-box !important;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .b1 {
        width: 100%;
        height: 100%;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        z-index: 1;

        .popup1 {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background-color: rgba(0, 0, 0, 0.4);
            z-index: 2;

            .p_bg {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
            }
        }

        .bg {
            width: 100%;
            height: 228px;
            background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
        }
    }

    .back {
        width: 1200px;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .body {
        width: 1200px;
        height: 96%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .top {
            width: 100%;
            display: flex;
            align-items: center;
            margin-top: 20px;

            .t_left {
                position: relative;
                width: 100px;
                height: 100px;
                display: flex;
                flex-direction: column;
                align-items: center;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background-color: #c2c2c2;
                }

                div {
                    width: 54px;
                    height: 22px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #2992FF;
                    font-weight: 500;
                    font-size: 14px;
                    color: #2992FF;
                    text-align: center;
                    line-height: 22px;
                    position: absolute;
                    bottom: -6px;
                }
            }

            .t_right {
                flex: 1;
                margin-left: 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .tr_left {

                    div:nth-child(1) {
                        font-weight: bold;
                        font-size: 28px;
                        color: #000000;
                        margin-bottom: 18px;
                    }

                    div:nth-child(2) {
                        font-weight: 500;
                        font-size: 16px;
                        color: #000000;
                    }
                }

                .tr_right {
                    width: 130px;
                    height: 36px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #FFFFFF;
                    font-weight: 800;
                    font-size: 16px;
                    color: #333333;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 10px;
                    }
                }
            }
        }

        .center {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 40px 0;

            .c_left {
                display: flex;
                align-items: center;

                div:nth-child(1) {
                    font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                    margin-right: 20px;
                }

                div:nth-child(2) {
                    font-weight: 500;
                    font-size: 14px;
                    color: #999999;
                }
            }

            .c_right {
                width: 124px;
                height: 36px;
                background: #399AFF;
                border-radius: 8px 8px 8px 8px;
                font-weight: 800;
                font-size: 16px;
                color: #FFFFFF;
                text-align: center;
                line-height: 36px;
                letter-spacing: 1px;
                cursor: pointer;
            }
        }

        .bottom {
            width: 100%;
            height: 0;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 20px;

            .b_top {
                width: 100%;
                height: 42px;
                border-radius: 4px;
                background: #F4F6FB;
                display: flex;
                align-items: center;

                div {
                    box-sizing: border-box;
                    padding: 0 10px;
                    text-align: center;
                }

                div:nth-child(1) {
                    // width: 180px;
                    flex: 2;
                }

                div:nth-child(2) {
                    // width: 120px;
                    flex: 1;
                }

                div:nth-child(3) {
                    // width: 80px;
                    flex: 1;
                }

                div:nth-child(4) {
                    // width: 80px;
                    flex: 1;
                }

                div:nth-child(5) {
                    // width: 80px;
                    flex: 1;
                }

                div:nth-child(6) {
                    // width: 260px;
                    flex: 2;
                }

                div:nth-child(7) {
                    // width: 180px;
                    flex: 2;
                }

                div:nth-child(8) {
                    // width: 220px;
                    flex: 2;
                }
            }

            .b_bottom::-webkit-scrollbar {
                display: none;
            }

            .b_bottom {
                width: 100%;
                height: 0;
                flex: 1;
                overflow-y: scroll;

                .bb_item {
                    width: 100%;
                    height: 78px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid#F2F3F5;

                    div {
                        box-sizing: border-box;
                        padding: 0 10px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .bb_1 {
                        flex: 2;
                        // width: 180px;
                    }

                    .bb_2 {
                        flex: 1;

                    }

                    .bb_3 {
                        flex: 1;

                        div {
                            width: 60px;
                            height: 20px;
                            background: #E1F0FF;
                            border-radius: 6px 6px 6px 6px;
                            font-weight: 500;
                            font-size: 12px;
                            color: #2992FF;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }

                    .bb_4 {
                        flex: 1;

                        div {
                            width: fit-content;
                            height: 20px;
                            background: #D7FFE6;
                            border-radius: 6px 6px 6px 6px;
                            font-weight: 500;
                            font-size: 12px;
                            color: #27C189;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }

                    .bb_5 {
                        flex: 1;

                        .b5img {
                            width: 80px;
                            height: 60px;
                        }
                    }

                    .bb_6 {
                        flex: 2;
                        // width: 260px;
                        font-weight: 500;
                        font-size: 14px;
                        color: #252525;
                        line-height: 26px;

                        .bb6 {
                            width: 100%;
                            height: 50px;
                        }
                    }

                    .bb_7 {
                        flex: 2;
                        // width: 180px;
                        font-weight: 500;
                        font-size: 14px;
                        color: #252525;
                    }

                    .bb_8 {
                        flex: 2;
                        // width: 220px;
                        display: flex;
                        align-items: center;

                        .bb8_btn1 {
                            font-weight: 500;
                            font-size: 13px;
                            color: #2992FF;
                            margin-right: 15px;
                            cursor: pointer;
                        }

                        .bb8_btn2 {
                            font-weight: 500;
                            font-size: 13px;
                            color: #CF1400;
                            cursor: pointer;

                        }
                    }
                }
            }
        }
    }</style>